import { ReactNode, useState } from 'react';

import Button from '@components/buttons/Button';
import { LineAwesomeIcon } from '@components/icons/LineAwesomeIcon';
import { AsyncImage } from '@components/layout/AsyncImg';
import { Skeleton } from '@components/layout/Skeleton/Skeleton';

import userIconUrl from './assets/user.svg';

export interface ProfileHeaderPerformanceMetric {
  count?: number;
  label: string;
  to: string;
}

interface ProfileHeaderProps {
  avatarUrl: string;
  title: string;
  isClaimed: boolean;
  handleClaim?: () => void;
  performanceMetrics: ProfileHeaderPerformanceMetric[];
  action?: ReactNode;
}

export const ProfileHeader = ({
  avatarUrl,
  title,
  isClaimed,
  handleClaim,
  performanceMetrics,
  action,
}: ProfileHeaderProps) => {
  const [hideImage, setHideImage] = useState(!avatarUrl);

  return (
    <div className="d-flex align-items-center gap-3">
      <div>
        <AsyncImage
          placeholder={
            !hideImage ? (
              <div
                style={{
                  width: 12 * 7,
                  height: 12 * 7,
                  borderRadius: 500,
                  overflow: 'hidden',
                  border: '2px solid rgba(255,255,255,.7)',
                }}
              >
                <Skeleton height={12 * 7} />
              </div>
            ) : undefined
          }
          src={hideImage ? userIconUrl : (avatarUrl ?? userIconUrl)}
          onError={() => setHideImage(true)}
          style={{
            width: 12 * 7,
            height: 12 * 7,
            borderRadius: 500,
            objectFit: 'cover',
            border: '2px solid rgba(255,255,255,.7)',
          }}
        />
      </div>

      <div className="w-100">
        <div className="d-flex align-items-center gap-2 justify-content-between w-100">
          <div>
            <strong>{title}</strong>
          </div>
          <div>
            {!isClaimed && (
              <div style={{ margin: '-.5rem 0' }}>
                <Button roundness="rounded" onClick={handleClaim}>
                  Claim
                </Button>
              </div>
            )}
          </div>
        </div>
        <div
          className="d-flex gap-1 my-1 align-items-center"
          style={{ fontSize: '.7rem', lineHeight: 1, opacity: 0.7 }}
        >
          <span>Performance Insights</span>
          <div onClick={() => {}}>
            <LineAwesomeIcon name="info-circle" />
          </div>
        </div>
        <div className="d-flex gap-4">
          {performanceMetrics.map((metric) => (
            <div
              key={`${metric.count}-${metric.label}`}
              // onClick={() => navigate(metric.to)}
              style={{ lineHeight: 1.2 }}
            >
              <div style={{}}>
                <strong>{metric.count ?? 0}</strong>
              </div>
              <div style={{ fontSize: '.7rem' }}>{metric.label}</div>
            </div>
          ))}
        </div>
      </div>

      {action && <div className="ml-auto">{action}</div>}
    </div>
  );
};
